import { string } from 'yup';

const rule = {
	name: 'isNotPOBox',
	method ({ message } = { message: 'We are unable to ship to P.O. Box addresses.' }) {

		return this.test('isNotPOBox', message, function (value) {

			const regex = /^p.?\s?o.?\s*box.*|^(p.?\s?o.?\s?|pob|box)\s?#?[0-9]+|^post office box/i;
			const { createError } = this;
			return !regex.test(value) || createError({ message });

		});

	},
	schemaType: string
};

export default rule;
